import FormHeader from "@/components/booking/FormHeader.tsx";
import {FormControl, FormField, FormItem, FormLabel, FormMessage} from "@/components/ui/form.tsx";
import {useFormContext} from "react-hook-form";
import {z} from "zod";
import {BookingFormSchema} from "@/components/booking/form/BookingFormSchema.ts";
import {RadioGroup, RadioGroupItem} from "@/components/ui/radio-group.tsx";
import {BookingCalendar} from "@/components/booking/form/calendar/BookingCalendar.tsx";
import {BookingDurationHelper} from "@/lib/enum/BookingDuration.ts";
import {useContext} from "react";
import {OscarContext, OscarContextType} from "@/components/context/OscarContext.tsx";
import {BookingKindHelper} from "@/lib/enum/BookingKind.ts";

export function DatesForm() {
    const {control, watch} = useFormContext<z.infer<typeof BookingFormSchema>>();
    const {localConfig} = useContext(OscarContext) as OscarContextType
    // Time Data
    const [startDate, endDate] = watch(["startDate", "endDate"]);
    const binKind = watch("binKind");

    return (
        <div className={"os-app-row os-flex os-flex-col os-gap-4"}>
            <FormHeader>Dates</FormHeader>
            <FormField
                control={control}
                name="duration"
                render={({field}) => (
                    <FormItem>
                        <FormLabel className={"os-mb-1"}>How long would like to keep the {BookingKindHelper.getBookingKindSlug(binKind)} for?</FormLabel>
                        <FormControl>
                            <RadioGroup
                                onValueChange={field.onChange}
                                defaultValue={field.value}
                            >
                                {BookingDurationHelper.getOptions().map((duration) => (
                                    <FormItem
                                        key={duration}
                                        className="os-flex os-flex-row os-items-center os-justify-center os-gap-2 os-flex-1 !os-space-y-0 os-py-2">
                                        <FormControl className={"os-brand-text"}>
                                            <RadioGroupItem value={duration}/>
                                        </FormControl>
                                        <FormLabel className="font-normal">
                                            {BookingDurationHelper.getBookingDurationLabel(duration, localConfig.brand)}
                                        </FormLabel>
                                    </FormItem>
                                ))}
                            </RadioGroup>
                        </FormControl>
                        <FormMessage/>
                    </FormItem>
                )}
            />

            <div>
                <FormLabel>When do you need the {BookingKindHelper.getBookingKindSlug(binKind)}?</FormLabel>
                <BookingCalendar/>
            </div>

            {startDate && endDate && (
                <div className={"os-flex os-flex-col os-items-center os-gap-2 os-mt-2"}>
                    <FormLabel>Selected Dates</FormLabel>
                    <div>{startDate?.toLocaleDateString()} - {endDate?.toLocaleDateString()}</div>
                </div>
            )}

            {control.getFieldState("startDate").error?.message || control.getFieldState("endDate").error?.message ? (
                <p className={"os-text-sm os-font-medium os-text-destructive os-text-center"}>Please choose a valid drop and pickup
                    date for your {BookingKindHelper.getBookingKindSlug(binKind)}.</p>
            ) : null}
        </div>
    );
}